import {
    publicRequest,
  userRequest,
  } from "../requestMethods/requestMethods";

  const safeFolderSegment = (folderName) =>
    encodeURIComponent(String(folderName || "general").trim());


  async function uploadVideo(folderName,file) {
    return await userRequest.post(`/gcp-cloud/upload/${safeFolderSegment(folderName)}`, file, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  async function uploadGcpVideo(folderName,file) {
    return await userRequest.post(`/gcp-cloud/upload-chunk/${safeFolderSegment(folderName)}`, file, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  async function uploadImage(folderName,file) {
    return await userRequest.post(`/gcp-cloud/uploadImage/${safeFolderSegment(folderName)}`, file, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  async function getFolder(){
    return await publicRequest.get('/gcp-cloud/getfolders')
  }

  export {getFolder,uploadImage,uploadVideo,uploadGcpVideo};